import React from 'react';
import { Box, Typography, Button } from '@mui/material';

import { useAuth } from '../../contexts/AuthContext';
import StatusChip from '../common/StatusChip';

// La selección de cliente vive en ClientPicker, debajo del encabezado.
const OrderHeader = ({ order, onCancel, cancelLabel = 'Cancelar' }) => {
    const { user } = useAuth();

    if (!order) return null;

    return (
        <Box sx={{ bgcolor: 'white', borderBottom: '1px solid #e7edf3', px: 3, py: 1.5, pt: { xs: 7, md: 1.5 } }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 2 }}>
                <Box sx={{ minWidth: 0 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, flexWrap: 'wrap' }}>
                        <Typography variant="h6" sx={{ fontWeight: 700, color: '#0e141b', fontSize: { xs: '1.125rem', md: '1.25rem' }, whiteSpace: 'nowrap' }}>
                            {order.status === 'borrador' ? 'Nuevo Pedido' : 'Editar Pedido'} {order.order_number}
                        </Typography>
                        <StatusChip status={order.status} sx={{ fontSize: '0.75rem', height: 20 }} />
                    </Box>
                    {user?.is_wholesale_client && (
                        <Typography sx={{ color: '#4e7397', fontSize: '0.875rem' }}>
                            Cliente: <Box component="span" sx={{ color: '#0e141b', fontWeight: 600 }}>{order.client?.name || user.first_name || user.username}</Box>
                        </Typography>
                    )}
                </Box>
                <Button
                    variant="outlined"
                    size="small"
                    onClick={onCancel}
                    sx={{
                        flexShrink: 0, borderColor: '#e7edf3', color: '#0e141b', height: 32, px: 2,
                        fontSize: '0.875rem', fontWeight: 500, textTransform: 'none',
                        '&:hover': { borderColor: '#e7edf3', bgcolor: '#f5f5f5' },
                    }}
                >
                    {cancelLabel}
                </Button>
            </Box>
        </Box>
    );
};

export default OrderHeader;
